const getGapMonthsWithYear = (start, end) => {
  const startDate = new Date(start);
  const endDate =
    typeof end === "string" && end.toLowerCase() === "now"
      ? new Date()
      : new Date(end);
  let months = (endDate.getFullYear() - startDate.getFullYear()) * 12;
  months -= startDate.getMonth();
  months += endDate.getMonth();
  if (months <= 0) return "0 months";

  const years = Math.floor(months / 12);
  const remMonths = months % 12;
  const parts = [];
  if (years > 0) {
    parts.push(`${years} ${years === 1 ? "year" : "years"}`);
  }
  if (remMonths > 0) {
    parts.push(`${remMonths} ${remMonths === 1 ? "month" : "months"}`);
  }
  return parts.join(" and ");
};

export { getGapMonthsWithYear };
